import type { ComponentProps } from "react";
import type { ViatorProductType } from "../lib/schemas/viator";
import { ViatorImageCard } from "./shared";

export const ViatorAd = ({
  product,
  className,
  loading,
}: {
  product: ViatorProductType;
  className?: string;
  loading?: ComponentProps<"img">["loading"];
}) => {
  return (
    <ViatorImageCard
      title={product.title}
      imageUrl={
        product.images[0].variants.sort((a, b) => b.width - a.width)[4].url
      }
      product={product}
      className={className}
      loading={loading}
    />
  );
};
